import { useCallback, useSyncExternalStore } from 'react';
import {
  clearSupportSession,
  getSupportSession,
  setSupportSession,
  subscribeToSupportSession,
  type SupportSession,
} from './session';

/**
 * The active support session, re-rendering when it changes.
 *
 * `useSyncExternalStore` rather than context: the store is also read from the
 * axios interceptor and from `getCurrentOrganisationId`, neither of which is a
 * component, so the plain module has to be the source of truth. A context on
 * top would be a second copy that can disagree with the one actually being
 * sent on requests.
 */
export function useSupportSession(): {
  session: SupportSession | null;
  isSupportSession: boolean;
  enter: (session: SupportSession) => void;
  exit: () => void;
} {
  const session = useSyncExternalStore(
    subscribeToSupportSession,
    getSupportSession,
    () => null,
  );

  const enter = useCallback((next: SupportSession) => setSupportSession(next), []);
  const exit = useCallback(() => clearSupportSession(), []);

  return { session, isSupportSession: session !== null, enter, exit };
}
